"use client";

import { useEffect } from "react";
import {
  detectPlatform,
  getInAppBrowserType,
} from "@/lib/utils/in-app-browser";

/**
 * Tag <html> with data-inapp-browser (e.g. "threads", "kakaotalk") and
 * data-inapp-platform ("ios" | "android") when the page runs inside a
 * third-party in-app browser (NOT our Capacitor native app).
 *
 * globals.css zeroes the phantom safe-area insets for Android in-app
 * WebViews behind these attributes: they report env(safe-area-inset-top/
 * bottom) (~34px / ~48px on Threads) even though the status bar and the OS
 * navigation bar are handled outside the WebView, so pt-safe / pb-safe would
 * otherwise paint that as a phantom band above the header and below the nav.
 * iOS in-app browsers render correctly and Capacitor native
 * (getInAppBrowserType()==="unknown") never enters this path.
 */
export function InAppBrowserEnvironment() {
  useEffect(() => {
    const type = getInAppBrowserType();
    if (type === "unknown") return;

    const root = document.documentElement;
    root.dataset.inappBrowser = type;
    root.dataset.inappPlatform = detectPlatform();
    return () => {
      delete root.dataset.inappBrowser;
      delete root.dataset.inappPlatform;
    };
  }, []);
  return null;
}
